




























































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import ChildAccountsInjectorMixin from "@/mixins/childAccountsInjectorMixin";
import ClientMixin from "@/mixins/clientMixin";
import Context from "@/mixins/context";

// Enums/Data
import { ListDisplayMode } from "@/data/constants";

// Types
import { IChildAccount } from "@/models/clients";

@Component({
  components: {
    "client-list-item": () =>
      import("@/components/app/admin/clients/clientListItem.vue")
  }
})
export default class ChildAccountsListItem extends Mixins(
  ClientMixin,
  ChildAccountsInjectorMixin,
  Context
) {
  // Props

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public childAccount!: IChildAccount;

  @Prop({ default: ListDisplayMode.TABLE })
  public displayMode!: ListDisplayMode;

  // Methods

  public canImpersonateChild({
    allow_impersonation,
    child_client
  }: IChildAccount) {
    if (!allow_impersonation) return false;
    return child_client?.has_login ?? true;
  }

  public async handleCta() {
    if (this.isAdmin && this.client?.id)
      return this.$router.push({
        name: "adminClient",
        params: {
          clientId: this.client?.id
        }
      });

    if (this.isClient && this.canImpersonate)
      return this.$childAccountsMethods.impersonateChild(this.childAccount);
  }

  // Computed

  public get showSkeletons() {
    return this.$_.isNull(this.childAccount);
  }

  public get client() {
    return this.childAccount?.child_client;
  }

  public get clientName() {
    return this.getClientName({
      client: this.childAccount?.child_client,
      clientId: this.childAccount?.child_client?.id,
      orEmail: false
    });
  }

  public get defaultEmail() {
    return this.client?.default_email?.email;
  }

  public get canImpersonate() {
    return this.childAccount?.allow_impersonation;
  }

  public get isImpersonating() {
    const key = `${this.childAccount?.child_client_id}_impersonation`;
    return !!this.$childAccountsData.isProcessing?.[key];
  }

  public get action() {
    if (this.isAdmin) return this.$t("_action.go_to_child_client");
    if (this.canImpersonate) return this.$t("_action.login_as_child");
    return this.$t("_.login_disabled_by_child");
  }

  public get actionIsDisabled() {
    if (this.isImpersonating) return true;
    if (!this.canImpersonate && !this.isAdmin) return true;
    return false;
  }
}
